import {
  AppstoreFilled,
  CommentOutlined,
  FileTextFilled,
  FileTextOutlined,
  FontColorsOutlined,
  ShopOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { ReactNode } from 'react';
import routeNames from '../../router/src/routeNames';

export interface MenuItemProps {
  path?: string;
  name: string;
  icon?: ReactNode;
  children?: MenuItemProps[];
}

export interface RouteProps {
  path: string;
  children: MenuItemProps[];
}

const layoutRouteProps: RouteProps = {
  path: routeNames.home,
  children: [
    {
      path: routeNames.dashboard,
      name: 'Dashboard',
      icon: <AppstoreFilled />,
    },
    {
      path: routeNames.investor,
      name: 'Investors',
      icon: <TeamOutlined />,
      children: [
        {
          path: routeNames.investorList,
          name: 'List',
        },
        {
          path: routeNames.deposit,
          name: 'Top Up',
        },
        {
          path: routeNames.withdrawal,
          name: 'Withdrawal',
        },
        {
          path: routeNames.investorRecorder,
          name: 'Investor Recorder',
        },
        {
          path: routeNames.manageUsersList,
          name: 'Manage Users',
        },
        {
          path: routeNames.serviceFeeRebateList,
          name: 'Service Fee Rebate',
        },
        {
          path: routeNames.investorTransactionReport,
          name: 'Investor Transaction Report',
        },
      ],
    },
    {
      path: routeNames.portfolio,
      name: 'Portfolio',
      icon: <FileTextOutlined />,
      children: [
        {
          path: routeNames.portfolioType,
          name: 'Portfolio Type',
        },
        {
          path: routeNames.portfolioByInvoice,
          name: 'By Invoice',
        },
        {
          path: routeNames.portfolioByTermLoan,
          name: 'By Term Loan',
        },
      ],
    },
    {
      path: routeNames.autoInvest,
      name: 'Auto Invest',
      icon: <FileTextOutlined />,
      children: [
        {
          path: routeNames.autoInvestByInvoice,
          name: 'By Invoice',
        },
        {
          path: routeNames.autoInvestByTermLoan,
          name: 'By Term Loan',
        },
        {
          path: routeNames.autoInvestExclusionList,
          name: 'Auto Invest Exclusion List',
        },
        {
          path: routeNames.autoInvestSpecialAllocation,
          name: 'Special Allocation',
        },
        {
          path: routeNames.autoInvestInternalFunding,
          name: 'Internal Funding',
        },
      ],
    },
    {
      path: routeNames.secondaryMarketTransactionsList,
      name: 'Secondary Market Transactions',
      icon: <ShopOutlined />,
    },
    {
      path: routeNames.otherTransaction,
      name: 'Other Transaction',
      icon: <FileTextFilled />,
      children: [
        {
          path: routeNames.otherTransactionList,
          name: 'Other Transaction List',
        },
        {
          path: routeNames.otherTransactionManage,
          name: 'Manage Other Transaction',
        },
      ],
    },
    {
      path: routeNames.introducer,
      name: 'Introducer',
      icon: <FileTextOutlined />,
      children: [
        {
          path: routeNames.introducerList,
          name: 'Introducer List',
        },
        {
          path: routeNames.introducerGroupList,
          name: 'Introducer Group List',
        },
        {
          path: routeNames.referralCodeList,
          name: 'Referral Code List',
        },
      ],
    },
    {
      path: routeNames.statement,
      name: 'Statements',
      icon: <FileTextOutlined />,
      children: [
        {
          path: routeNames.statementRelease,
          name: 'Statements Release',
          children: [
            {
              path: routeNames.upcomingStatement,
              name: 'Upcoming Statements',
            },
            {
              path: routeNames.releasedStatement,
              name: 'Released Statements',
            },
          ],
        },
        {
          path: routeNames.generateStatement,
          name: 'Generate Statement',
        },
      ],
    },
    {
      path: routeNames.commentTemplateList,
      name: 'Comment',
      icon: <CommentOutlined />,
    },
    {
      path: routeNames.gradingLimitsList,
      name: 'Grading Limits',
      icon: <FontColorsOutlined />,
    },
    {
      path: routeNames.eInvoice,
      name: 'e-Invoice',
      icon: <FileTextOutlined />,
    },
  ],
};

export default layoutRouteProps;
